import htmlComponent from 'htmlcomponent'

export default function (dom, opts) {
    console.log('in teamlist (extended filters)!')

    const departmentFilterInputs = Array.from(
        dom.querySelectorAll('input[name="filters_department"]')
    )

    const headlineFilterInputs = Array.from(
        dom.querySelectorAll('input[name="filters_headline"]')
    )

		const members = Array.from(
				dom.querySelectorAll('.team-element__member')
		)

		if (members.length === 0) {
				console.warn('teamlist: no .team-element__member found - check template')
				return
		}

    departmentFilterInputs.forEach((checkbox) => {
        checkbox.addEventListener('change', applyFilters)
    })

    headlineFilterInputs.forEach((checkbox) => {
        checkbox.addEventListener('change', applyFilters)
    })

    applyFilters()

    function applyFilters () {
			const selectedDepartmentIds = new Set(
					departmentFilterInputs
							.filter((checkbox) => checkbox.checked)
							.map((checkbox) => String(checkbox.value))
			)

			const selectedHeadlineIds = new Set(
					headlineFilterInputs
							.filter((checkbox) => checkbox.checked)
							.map((checkbox) => String(checkbox.value))
			)

			const departmentFilterActive = selectedDepartmentIds.size > 0
			const headlineFilterActive = selectedHeadlineIds.size > 0

			console.log('Selected department filters:', Array.from(selectedDepartmentIds))
			console.log('Selected headline filters:', Array.from(selectedHeadlineIds))

			// Reset wenn nix aktiv
			if (!departmentFilterActive && !headlineFilterActive) {
					members.forEach((member) => { member.style.display = '' })
					return
			}

			members.forEach((member) => {
					// Department-Filter: data-departments
					const deptAttrRaw = member.getAttribute('data-departments') || ''
					const memberDepartmentIds = deptAttrRaw
							.split(',')
							.map((s) => s.trim())
							.filter((s) => s.length > 0)

					const memberMatchesDepartments =
							!departmentFilterActive ||
							memberDepartmentIds.some((id) => selectedDepartmentIds.has(String(id)))

					// Headline-Filter: data-headlines (NEU im Template)
					const hlAttrRaw = member.getAttribute('data-headlines') || ''
					const memberHeadlineIds = hlAttrRaw
							.split(',')
							.map((s) => s.trim())
							.filter((s) => s.length > 0)

					const memberMatchesHeadlines =
							!headlineFilterActive ||
							memberHeadlineIds.some((id) => selectedHeadlineIds.has(String(id)))

					member.style.display = (memberMatchesDepartments && memberMatchesHeadlines) ? '' : 'none'
			})
	}

}
